import moment from "moment";

export function getPlaysGrowthDerivedStats({ playsGrowth, uccsStats }) {
  if(!playsGrowth || !uccsStats) return null;

  const byDate = playsGrowth.byDateLast90d || {};
  const today = moment().startOf("day");
  const startOfWeek = moment().startOf("isoWeek");
  const cutoff30 = today.clone().subtract(29, "days");
  const cutoff7  = today.clone().subtract(6, "days");

  let playedThisWeek = 0;
  let last7Days = 0;
  let last30Days = 0;
  Object.entries(byDate).forEach(([d, n]) => {
    const m = moment(d, "YYYY-MM-DD");
    if(m.isSameOrAfter(startOfWeek)) playedThisWeek += +n;
    if(m.isSameOrAfter(cutoff7)) last7Days += +n;
    if(m.isSameOrAfter(cutoff30)) last30Days += +n;
  });

  const totalPlayed = playsGrowth.totalPlayed;
  const total30dAgo = totalPlayed - last30Days;
  const total90dAgo = playsGrowth.total90dAgo;

  const milestoneStep = totalPlayed >= 5000 ? 1000 : totalPlayed >= 1000 ? 500 : totalPlayed >= 250 ? 250 : 100;
  const nextMilestone = (Math.floor(totalPlayed / milestoneStep) + 1) * milestoneStep;
  const toGo = nextMilestone - totalPlayed;
  const past7DayPace = last7Days / 7;
  const daysToGo = past7DayPace > 0 ? Math.ceil(toGo / past7DayPace) : null;
  const milestonePct = nextMilestone > 0 ? (totalPlayed / nextMilestone) * 100 : 0;

  const newThisWeek = uccsStats.addedThisWeek;
  const reviewsThisWeek = Math.max(0, playedThisWeek - newThisWeek);

  let running = total90dAgo;
  const cumulative = [];
  const dateLabels = [];
  for(let i = 89; i >= 0; i--) {
    const d = moment().subtract(i, "days");
    running += (byDate[d.format("YYYY-MM-DD")] || 0);
    cumulative.push(running);
    dateLabels.push(d.format("MMM D, YYYY"));
  }

  // If past-7-day pace is 0, fall back to 5/day so the forecast line isn't flat for inactive users.
  const forecastPace = past7DayPace > 0 ? past7DayPace : 5;
  const forecastDays = 7;
  const forecastLabels = [];
  const forecastCumulative = [];
  let forecastRunning = totalPlayed;
  for(let i = 1; i <= forecastDays; i++) {
    forecastRunning += forecastPace;
    forecastCumulative.push(Math.round(forecastRunning));
    forecastLabels.push(moment().add(i, "days").format("MMM D, YYYY"));
  }
  const projectedIn7Days = Math.round((totalPlayed + forecastPace * 7) / 50) * 50;

  return {
    totalPlayed,
    total30dAgo,
    total90dAgo,
    playedThisWeek,
    last7Days,
    past7DayPace,
    milestoneStep,
    nextMilestone,
    toGo,
    daysToGo,
    milestonePct,
    newThisWeek,
    reviewsThisWeek,
    cumulative,
    dateLabels,
    forecastCumulative,
    forecastLabels,
    projectedIn7Days
  };
}
